import { render } from "./NewOverview.vue?vue&type=template&id=565b2e6f"
import script from "./NewOverview.vue?vue&type=script&lang=js"
export * from "./NewOverview.vue?vue&type=script&lang=js"

import "./NewOverview.vue?vue&type=style&index=0&id=565b2e6f&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/NewOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "565b2e6f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('565b2e6f', __exports__)) {
    console.log('reload')
    api.reload('565b2e6f', __exports__)
  }
  
  module.hot.accept("./NewOverview.vue?vue&type=template&id=565b2e6f", () => {
    console.log('re-render')
    api.rerender('565b2e6f', render)
  })

}


export default __exports__